import React from 'react';

export const ServerErrorSvg: React.FC<{ className?: string }> = ({ className = 'w-72 h-48 sm:w-96 sm:h-64' }) => {
  return (
    <svg
      viewBox="0 0 500 300"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${className} mx-auto transition-all duration-300`}
    >
      {/* Background tracks */}
      <rect x="130" y="80" width="240" height="14" rx="7" fill="#E2E8F0" className="dark:fill-slate-800" />
      <rect x="90" y="115" width="320" height="14" rx="7" fill="#F1F5F9" className="dark:fill-slate-800/60" />
      <rect x="160" y="150" width="180" height="14" rx="7" fill="#E2E8F0" className="dark:fill-slate-800" />

      {/* "5" */}
      <path
        d="M175 90 H130 L125 135 C135 130 150 130 165 135 C180 142 185 160 180 180 C175 200 155 205 130 200"
        stroke="currentColor"
        strokeWidth="16"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
        className="text-slate-900 dark:text-white"
      />

      {/* Disconnected Plug / Lightning Center "0" */}
      <g transform="translate(250, 140)">
        <circle
          r="44"
          stroke="currentColor"
          strokeWidth="16"
          fill="none"
          className="text-slate-900 dark:text-white"
        />
        <path
          d="M5 -25 L-12 2 L2 2 L-5 25 L12 -2 L-2 -2 Z"
          fill="#ef4444"
          className="dark:fill-rose-500"
        />
      </g>

      {/* Second "0" */}
      <g transform="translate(350, 140)">
        <circle
          r="44"
          stroke="currentColor"
          strokeWidth="16"
          fill="none"
          className="text-slate-900 dark:text-white"
        />
      </g>
    </svg>
  );
};

export default ServerErrorSvg;
